export default "__VITE_ASSET__Ckql9Oox__"